import {SvgIcon} from "@material-ui/core";

export const CustomMapPinIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 12 16" {...props}>
            <path d="M6 8.5C7.10457 8.5 8 7.60457 8 6.5C8 5.39543 7.10457 4.5 6 4.5C4.89543 4.5 4 5.39543 4 6.5C4 7.60457 4.89543 8.5 6 8.5Z" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11 6.5C11 11 6 14.5 6 14.5C6 14.5 1 11 1 6.5C1 5.17392 1.52678 3.90215 2.46447 2.96447C3.40215 2.02678 4.67392 1.5 6 1.5C7.32608 1.5 8.59785 2.02678 9.53553 2.96447C10.4732 3.90215 11 5.17392 11 6.5V6.5Z" stroke="#757575" strokeLinecap="round" strokeLinejoin="round"/>
        </SvgIcon>
    )
}
